import { useContext } from 'react';
import PageContext from '../PageContext';
export default function useQuery() {
    var _a;
    var pageInstance = (_a = useContext(PageContext)) === null || _a === void 0 ? void 0 : _a.page;
    return pageInstance === null || pageInstance === void 0 ? void 0 : pageInstance.query;
}
